<template>
    <div id="contenedor-main-listado-Oficios-Autorizacion">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
              :soloLectura="soloLectura"
              :listadoOficiosAutorizacion="listadoOficiosAutorizacion"
              :total="total"
              :totalAutorizaciones="totalAutorizaciones"
              :totalCancelaciones="totalCancelaciones"
              :importeTotal="importeTotal"
              :cargando="cargando"
              @actualizar-opciones="$emit('actualizar-opciones', $event)">
            </desktop>
        </template>
        <template
            v-else>
            <desktop
              :soloLectura="soloLectura"
              :listadoOficiosAutorizacion="listadoOficiosAutorizacion"
              :total="total"
              :totalAutorizaciones="totalAutorizaciones"
              :totalCancelaciones="totalCancelaciones"
              :importeTotal="importeTotal"
              :cargando="cargando"
              @actualizar-opciones="$emit('actualizar-opciones', $event)">
            </desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoOficiosAutorizacion',
  props: {
    listadoOficiosAutorizacion: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    totalAutorizaciones: {
      type: Number,
      default: 0,
    },
    totalCancelaciones: {
      type: Number,
      default: 0,
    },
    importeTotal: {
      type: Number,
      default: 0,
    },
    cargando: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {
      soloLectura: false,
    };
  },
};
</script>

<style lang="scss">

</style>
